// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"src-components-flowable-IRBStudy-StudyStatusIcon___statusIcon"};